// extracted by mini-css-extract-plugin
module.exports = {"match-won-div":"RankDivBtn_match-won-div__1yW8x","battle-rank-div":"RankDivBtn_battle-rank-div__NRsIr","btn-div":"RankDivBtn_btn-div__3rrVW","btn-img":"RankDivBtn_btn-img__W2GQy"};